import axios from 'axios'
import { store } from '../../store/index'
import { setPercentage, setCancelToken } from '../../store/actions/percentage'

const baseUrl = "http://165.232.80.248:7000/"

export const fileUploadCall = async (endPoint, formData) => {
    setToken()
    const source = axios.CancelToken.source();

    const config = {
        headers: {
            'content-type': 'multipart/form-data',
        },
        baseURL: baseUrl,
        onUploadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            let percent = Math.floor((loaded * 100) / total)
            if (percent == 100)
                setPercentage(0)
            else
                setPercentage(percent)
        },
        cancelToken: source.token

    };
    setCancelToken(source)

    return await axios.post(endPoint, formData, config)
}

export const jsonUploadCall = (endPoint, formData) => {
    setToken()

    const config = {
        headers: {
            'content-type': 'application/json',
        },
        baseURL: baseUrl
    };
    return axios.post(endPoint, JSON.stringify(formData), config)
}
export const jsonPutCall = (endPoint, formData) => {
    setToken()

    const config = {
        headers: {
            'content-type': 'application/json',
        },
        baseURL: baseUrl
    };
    return axios.put(endPoint, JSON.stringify(formData), config)
}

export const filePutCall = (endPoint, formData) => {
    setToken()

    const config = {
        headers: {
            'content-type': 'multipart/form-data',
        },
        baseURL: baseUrl,
        onUploadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            let percent = Math.floor((loaded * 100) / total)
            if (percent == 100)
                setPercentage(0)
            else
                setPercentage(percent)
        }
    };
    return axios.put(endPoint, formData, config)
}

export const getCall = (endPoint, body = {}) => {
    setToken()

    const config = {
        headers: {
            'content-type': 'application/json',
        },
        baseURL: baseUrl,
    };
    return axios.post(endPoint, body, config)
}

export const deleteCall = (endPoint, data) => {

    setToken()
    const config = {
        headers: {
            'content-type': 'application/json',

        },
        baseURL: baseUrl,
        onUploadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            let percent = Math.floor((loaded * 100) / total)
            if (percent == 100)
                setPercentage(0)
            else
                setPercentage(percent)
        }
    };
    return axios.delete(endPoint, {
        headers: config.headers,
        baseURL: config.baseURL,
        data: data
    })
}
const setToken = async () => {
    axios.defaults.headers.common['Authorization'] = store.getState().auth.token
}
